import React from "react";
import Grid from "@material-ui/core/Grid";
import { H2 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import Text from "@origyn-sa/common-ui/src/components/atoms/Text";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import Table from "@origyn-sa/common-ui/src/components/organisms/Table";
import CardImage from "@origyn-sa/common-ui/src/components/atoms/CardImage";

const NFTItemContent = ({
  name,
  description,
  image,
  attributes,
  owner,
  isOwner,
  listing,
  onList,
  onUnlist,
  onSale,
  external_url,
  setOpenTransfer,
  onBuy,
  price,
  showApproval,
  onApproval,
  showListing,
  showTransfer,
  onRemoveApproval,
  actionChildren,
  imageChildren,
  ...details
}: any) => (
  <Grid container spacing={4}>
    <Grid item xs={12} sm={5} lg={4}>
      {imageChildren || <CardImage notFixed src={image} />}
      {description && (
        <>
          <Text spacing={1}>Description</Text>
          <Text spacing={1} color="neutral2">
            {description}
          </Text>
        </>
      )}
      {external_url && (
        <Text spacing={1} color="primary">
          <a href={external_url} target="_blank" rel="noreferrer">
            {external_url}
          </a>
        </Text>
      )}
    </Grid>
    <Grid item xs={12} sm={7} lg={8}>
      <H2>{name}</H2>
      {details.id && (
        <Text spacing={0.5} color="neutral2">
          ID: <span>{details.id}</span>
        </Text>
      )}
      {owner && (
        <Text spacing={0.5} color="neutral2">
          Owned by <span>{owner}</span>
        </Text>
      )}
      {price && onBuy && (
        <>
          <br />
          <Text spacing={0.5} color="neutral2">
            Price:
          </Text>
          <Text
            color="primary"
            size="large"
            style={{ fontSize: "24px", fontWeight: "bold" }}
          >
            {price}
          </Text>
          <br />
        </>
      )}
      {actionChildren}
      {showTransfer && isOwner && (
        <Button disabled={!owner} spacing={2} onClick={setOpenTransfer}>
          Transfer
        </Button>
      )}
      {listing && onBuy && (
        <Button disabled={!owner} spacing={2} onClick={onBuy}>
          Buy
        </Button>
      )}
      {isOwner && showListing && !listing && onList && (
        <Button outlined spacing={2} onClick={onList}>
          List
        </Button>
      )}
      {isOwner && showListing && listing && onUnlist && (
        <Button outlined spacing={2} onClick={onUnlist}>
          Unlist
        </Button>
      )}
      {showApproval && (
        <Button outlined spacing={2} onClick={onApproval}>
          Approvals
        </Button>
      )}
      {/* {listing && (
        <div>
          Listing debug:
          <br />
          {JSON.stringify({
            ...listing,
            listingPrice: listing.listingPrice.toString(),
            updatedAt: listing.updatedAt.toString(),
          })}
        </div>
      )} */}
      {attributes ? (
        <div style={{ padding: "8px", overflowX: "auto" }}>
          <Table
            fullWidth
            noDataMessage="No data available"
            tableHeadline="NFT Details"
            data={attributes.map((data: any) => [
              { label: data.key || data.trait_type, colspan: "1" },
              { label: data.value, colspan: "2" },
            ])}
            spacing={3}
          />
        </div>
      ) : null}
    </Grid>
  </Grid>
);

export default NFTItemContent;
